import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import authService from 'services/authService';
import { useAuth } from 'hooks/useAuth';
import "./SignIn.css";

export const SignIn = () => {
  const navigate = useNavigate();
  const { setIsLogged, setStorage } = useAuth();

  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    }
  });

  const showError = (message) => {
    Toast.fire({
      icon: 'error',
      title: message
    });
  };

  const showSuccess = (message) => {
    Toast.fire({
      icon: 'success',
      title: message
    });
  };

  // Validación de email
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Validar formulario
  const validateForm = () => {
    const newErrors = {};

    if (!formData.email.trim()) {
      newErrors.email = 'El correo electrónico es requerido';
    } else if (!validateEmail(formData.email)) {
      newErrors.email = 'Ingresa un correo electrónico válido';
    }

    if (!formData.password) {
      newErrors.password = 'La contraseña es requerida';
    } else if (formData.password.length < 6) {
      newErrors.password = 'La contraseña debe tener al menos 6 caracteres';
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      showError('Por favor corrige los errores del formulario');
      return false;
    }

    return true;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);

    try {
      const result = await authService.login({
        email: formData.email.trim().toLowerCase(),
        password: formData.password
      });

      if (result.error) {
        showError(result.data || 'Credenciales incorrectas');
        setLoading(false);
        return;
      }

      const { token, user } = result.data.data;

      setStorage('data', { token });
      setStorage('user', user);
      setIsLogged(true);

      showSuccess('Inicio de sesión exitoso');

      // Espera breve antes de redirigir
      setTimeout(() => {
        navigate("/welcome")
      }, 1200);

    } catch (err) {
      showError('Error de conexión. Intenta nuevamente.');
      setLoading(false);
    }
  };

  const handleBackToLanding = () => {
    navigate('/');
  };

  return (
    <div className="login-page">
      <div className="back-to-landing-container">
        <button className="back-to-landing" onClick={handleBackToLanding}>
          ← Volver al Inicio
        </button>
      </div>

      <div className="login-container">
        <div className="login-logo">
          <div className="logo-login" onClick={() => navigate("/")}>
            <img
              src="https://cdn2.paraty.es/mariabonita-corpo/images/15cba433451f2bd=s250"
              height="46"
              alt="María Bonita Logo"
            />
          </div>
        </div>

        <h2 className="login-title">Bienvenido</h2>
        <p className="login-subtitle">Inicia sesión para acceder a tu portal</p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Correo Electrónico</label>
            <input
              type="email"
              name="email"
              className={`form-input ${errors.email ? 'input-error' : ''}`}
              placeholder="usuario@ejemplo.com"
              value={formData.email}
              onChange={handleChange}
              disabled={loading}
            />
            {errors.email && (
              <span className="error-message">{errors.email}</span>
            )}
          </div>

          <div className="form-group">
            <label className="form-label">Contraseña</label>
            <input
              type="password"
              name="password"
              className={`form-input ${errors.password ? 'input-error' : ''}`}
              placeholder="••••••••"
              value={formData.password}
              onChange={handleChange}
              disabled={loading}
            />
            {errors.password && (
              <span className="error-message">{errors.password}</span>
            )}
          </div>

          <div className="forgot-password">
            <Link to="/forgot-password">¿Olvidaste tu contraseña?</Link>
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-full"
            disabled={loading}
          >
            {loading ? 'Ingresando...' : 'Ingresar al Portal'}
          </button>

          <div className="register-link">
            <p>
              ¿No tienes cuenta? <Link to="/sign-up">Registrarse</Link>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};
